import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';
import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getFoodsBrandsImage, getPictureByKey } from '../../api';
export default {
  name: 'foods_brands_config',
  components: {
    draggable: draggable,
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      depot: {},
      pictureList: [],
      updateIndex: ''
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureList = picture[1] || [];
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      if (typeof this.updateIndex === 'number') {
        this.value.config.value[this.updateIndex]['brand_image'] = path;
      } else {
        this.value.config[this.updateIndex] = path;
      }
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(updateIndex) {
      this.updateIndex = updateIndex;
      this.showPictureLibrary = true;
    },
    deleteImg: function deleteImg() {
      this.value.config.site_image = '';
    },
    checkFlag: function checkFlag(rule, value, callback) {
      var showTabs = this.value.config.value.filter(function (i) {
        return i.flag;
      });
      if (showTabs.length < 1) {
        callback('至少选择一个品牌');
      } else {
        callback();
      }
    },
    emitUploadFile: function emitUploadFile(res, item) {
      var prop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'brand_image';
      this.$set(item, prop, "".concat(this.$ossurl).concat(res));
    },
    onUpload: function onUpload(ref, index) {
      if (ref === 'siteImage') {
        this.$refs[ref].uploadBanner();
      } else {
        this.$refs[ref][index].uploadBanner();
      }
    },
    changeCategory: function changeCategory(val) {
      var _this2 = this;
      if (val) {
        getFoodsBrandsImage({
          category_id: this.value.config.category_id
        }, this.info.module).then(function (res) {
          var _menu$childrens;
          var data = res.data;
          var menu = _this2.menuListFilter.find(function (i) {
            return i.id === val;
          });
          var children = menu === null || menu === void 0 ? void 0 : (_menu$childrens = menu.childrens) === null || _menu$childrens === void 0 ? void 0 : _menu$childrens.map(function (i) {
            var _data$i$id;
            return {
              id: i.id,
              name: i.name,
              brand_image: ((_data$i$id = data[i.id]) === null || _data$i$id === void 0 ? void 0 : _data$i$id.brand_image) || '',
              disabled: i.disabled,
              flag: true
            };
          });
          _this2.value.config.value = children || [];
        });
      } else {
        this.value.config.value = [];
      }
    }
  },
  created: function created() {
    var site_image = 'https://res.youlianfuwu.com/mini_program/shop/foods_brands_site_image.png';
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$si = _this$value$config.site_image_open,
      site_image_open = _this$value$config$si === void 0 ? 1 : _this$value$config$si,
      _this$value$config$is = _this$value$config.is_jump_home,
      is_jump_home = _this$value$config$is === void 0 ? 1 : _this$value$config$is,
      _this$value$config$bg = _this$value$config.bg_color,
      bg_color = _this$value$config$bg === void 0 ? '#ffffff' : _this$value$config$bg;
    this.$set(this.value, 'config', _objectSpread({
      name: '',
      description: '',
      category_id: '',
      site_image: site_image,
      value: [],
      is_jump_home: is_jump_home,
      //兼容新老组件 默认预置1
      site_image_open: site_image_open,
      //兼容新老组件 默认预置1
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index,
      //兼容新老组件 默认预置2
      bg_color: bg_color
    }, this.value.config));
    this.getPicture();
  },
  computed: {
    menuListFilter: function menuListFilter() {
      return this.menuList.filter(function (i) {
        return ['online_order'].includes(i.type);
      });
    }
  }
};